import React, { forwardRef } from 'react';
import { StyledRadio, StyledRadioLabel, Wrapper } from './styles';
import { getRandomString } from '@src/common';

type RadioProps = Omit<JSX.IntrinsicElements['input'], 'type' | 'ref'> & {
  label?: string;
};

const Radio = forwardRef<HTMLInputElement, RadioProps>((props: RadioProps, inputRef: React.Ref<HTMLInputElement>) => {
  const { label, id = getRandomString(5), ...rest } = props;

  return (
    <Wrapper>
      <StyledRadio id={id} type='radio' ref={inputRef} {...rest} />

      {label ? <StyledRadioLabel htmlFor={id}>{label}</StyledRadioLabel> : null}
    </Wrapper>
  );
});

Radio.displayName = 'Radio';

export default Radio;
